<template>
  <div class="full-screen flex-column align-center justify-center">
    <van-empty image="error" description="请求错误" />
    <van-button type="primary" to="/">妈妈来了首页</van-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style>
</style>